const activies = {
  path: '/assist',
  redirect: '/assist/home',
  component: () => import('@/layout/orderHeader'),
  children: [
    {
      path: 'home',
      name: 'home',
      meta: { title: '浙里加工对外协作平台' },
      component: () => import(/* webpackChunkName: "activities" */ '@/pages/activies/assist/index.vue')
    },
    {
      path: 'assistSearch/:type?',
      name: 'assistSearch',
      meta: { title: '找订单-资源企业-找加工点' },
      component: () => import(/* webpackChunkName: "activities" */ '@/pages/activies/assist/search.vue')
    },
    {
      path: 'release',
      name: 'AssistRelease',
      meta: { title: '发布加工需求' },
      component: () => import(/* webpackChunkName: "activities" */ '@/pages/member/assist/release.vue')
    },
    {
      path: 'detail/:id(\\d+)',
      name: 'detail',
      meta: { title: '需求详情' },
      component: () => import(/* webpackChunkName: "activities" */ '@/pages/member/assist/detail.vue')
    },
    {
      path: 'success',
      name: 'AssistSuccess',
      meta: { title: '发布成功' },
      component: () =>
        import(/* webpackChunkName: "purchase" */ '@/pages/member/assist/success')
    }
  ]
}

export default activies
